export default __webpack_public_path__ + "static/media/Kanto.62944b46.png";